import { render } from "./ViewWithTable.vue?vue&type=template&id=05e0d186"
import script from "./ViewWithTable.vue?vue&type=script&lang=js"
export * from "./ViewWithTable.vue?vue&type=script&lang=js"

import exportComponent from "/proyectos/servicios/ide-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__